// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a4b5cd9","667":"e10fdd0f","977":"bafb2d3b"}[chunkId] + ".chunk.js";
};